<mat-card class="daxa-card maps-card mb-25 border-radius bg-white border-none d-block">

    <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">
            Plants
          </h5>
        </mat-card-title>
    </mat-card-header>

    <mat-card-content class="d-flex flex-grow-1">
        <div *ngIf="isBrowser" id="map"></div>
    </mat-card-content>

</mat-card>